import { FieldDescription, FieldDescriptionProps, FieldLabel, FieldLabelProps } from './field';
import 'intl-tel-input/react';
import IntlTelInput from 'intl-tel-input/reactWithUtils';
import 'intl-tel-input/build/css/intlTelInput.css';
import classNames from 'classnames';

export type PhoneProps = FieldLabelProps &
  FieldDescriptionProps & {
    className?: string;
    value: any;
    onChange: (newValue: string) => any;
    onChangeValidity: (valid: boolean) => any;
    dataCy?: string;
  };

export const Phone = ({
  className,
  label = 'Phone number',
  labelType,
  labelWeight,
  description,
  value,
  onChange,
  onChangeValidity,
  isRequired = false,
  dataCy,
}: PhoneProps) => {
  return (
    <div className={classNames(className)}>
      <FieldLabel label={label} labelType={labelType} labelWeight={labelWeight} isRequired={isRequired} />
      <IntlTelInput
        onChangeNumber={onChange}
        onChangeValidity={onChangeValidity}
        initialValue={value}
        inputProps={{
          'data-cy': dataCy,
        }}
        initOptions={{
          initialCountry: 'auto',
          geoIpLookup: (callback) => {
            fetch('https://ipinfo.io', { headers: { accept: 'application/json' } })
              .then((res) => {
                if (res.ok) {
                  return res.json();
                } else {
                  callback('us');
                  Promise.reject(res);
                }
              })
              .then((data) => {
                callback(data.country);
              })
              .catch(() => callback('us'));
          },
          formatOnDisplay: true,
          formatAsYouType: true,
          separateDialCode: true,
          strictMode: true,
        }}
      />
      <FieldDescription description={description} />
    </div>
  );
};
